import { VoieDeRecours } from './sections/voies-de-recours.jsx'
import { RetourInfoContact } from './sections/retour-info-contact.jsx'
import { Plan } from './sections/plan.jsx'

export const NotFound = ({ url = '' }) => {
  return (
    <div class="site-width">
      <div class="header-wrapper mb-2 mb-md-3">
        <div class="container-fluid">
          <h1 class="pb-0 mt-1 mt-md-2 mb-1 mb-md-2">Déclaration d'accessibilité : {url}</h1>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-10 col-xl-8">
            <div class="alert-container alert-info mb-2" role="alert">
              <p class="alert">
                <span class="alert-icon icon-info" aria-hidden="true"></span>
                <span class="text-mw">La page d'où vous venez n'a pas encore fait l'objet d'un audit de conformité.</span>
              </p>
            </div>

            <Plan title={url} />

            <h2 class="mt-2">Etat de conformité</h2>
            <p>
              {url} est non conforme aux critères{' '}
              <abbr lang="en" title="Web Content Accessibility Guidelines" style="speak: spell-out;">
                WCAG
              </abbr>{' '}
              version 2.2 de niveau A et AA, car il n'existe aucun résultat d'audit de conformité en cours de validité permettant de mesurer les critères.
            </p>
            <p>
              Orange utilise une autre méthode de test que le{' '}
              <abbr title="Référentiel général d'amélioration de l'accessibilité" style="speak: spell-out;">
                RGAA
              </abbr>
              , les WCAG version 2.2 niveaux A et AA. <br />
              <a
                href="https://a11y-guidelines.orange.com/fr/cadrage/correspondance-rgaa-wcag/"
                target="_blank"
                title="Consulter le tableau de correspondance entre les RGAA et les WCAG (nouvelle fenêtre)"
              >
                Consulter le tableau de correspondance entre les{' '}
                <abbr title="Référentiel général d'amélioration de l'accessibilité" style="speak: spell-out;">
                  RGAA
                </abbr>{' '}
                et les{' '}
                <abbr lang="en" title="Web Content Accessibility Guidelines" style="speak: spell-out;">
                  WCAG
                </abbr>
                .
              </a>
            </p>

            <RetourInfoContact />

            <VoieDeRecours />
          </div>
        </div>
      </div>
    </div>
  )
}
